var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice notice--warning"},[_c('div',[_vm._v(" "+_vm._s(_vm.$t("checkout.addressChanged"))+" ")]),_c('div',{staticClass:"notice__button"},[_c('v-btn',{attrs:{"elevation":"2","color":"warning","x-small":""},on:{"click":_vm.reloadRates}},[_vm._v(_vm._s(_vm.$t("checkout.clickToReload")))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }